import {useEffect, useState} from 'react';
import {AddressComponent, DeliveryBillingAddress, Places} from '../../interfaces/cart-interfaces';
import {config} from '../../config-merchant';

declare const google: any

export default function GooglePlace(props: { dateJ: string, id: string, placeholder: string, name: string, onAddressSelected: any, disabled: boolean, addressDefault?: string }) {
    const [autocomplete, setAutocomplete] = useState<any>(null);
    const [addressG, setAddressG] = useState<string>(props.addressDefault);

    const handleAddressField = () => {
        setAutocomplete(new google.maps.places.Autocomplete(document.getElementById(props.id), {}));
    }

    const mapAddressObject = (addressObject: AddressComponent[]): DeliveryBillingAddress => {
        const mapping = {
            "country": "country",
            "locality": "locality",
            'postal_code': "postalCode",
            "route": "route",
            "street_number": "streetNumber"
        }
        const result: DeliveryBillingAddress = {country: '', locality: '', postalCode: '', route: '', streetNumber: ''};
        addressObject.forEach(o => {
            if (Object.keys(mapping).includes(o.types[0])) {
                result[mapping[o.types[0]]] = o.short_name;
            }
        })
        return result;
    }

    const handlePlaceSelect = () => {
        const places: Places = autocomplete.getPlace();
        const addressDetails = mapAddressObject(places.address_components);
        props.onAddressSelected({address: addressDetails, addressOneLine: places.formatted_address});
        setAddressG(places.formatted_address);
    }

    const onChange = (event) => {
        if (event.target.value === "") {
            props.onAddressSelected({address: "", addressOneLine: ""});
        }
        setAddressG(event.target.value);
    };

    useEffect(() => {
        handleAddressField();

        // https://stackoverflow.com/questions/29931712/chrome-autofill-covers-autocomplete-for-google-maps-api-v3
        const autocompleteInput = document.getElementById(props.id);
        const observerHack = new MutationObserver(function () {
            observerHack.disconnect();
            const autocomplete = document.getElementById(props.id);
            if (autocomplete !== null) {
                // autocomplete.setAttribute("autocomplete", "appyshop-" + props.dateJ);
                autocomplete.setAttribute("autocomplete", "new-password");
            }
        });
        observerHack.observe(autocompleteInput, {
            attributes: true,
            attributeFilter: ['autocomplete']
        });
    }, [])

    useEffect(() => {
        if (autocomplete !== null) {
            autocomplete.setFields(['formatted_address', 'address_components']);
            if (config.enabledDeliveryCountry.length < 5) {
                autocomplete.setComponentRestrictions({
                    country: config.enabledDeliveryCountry
                })
            }
            autocomplete.addListener("place_changed", handlePlaceSelect);
        }
    }, [autocomplete])

    return (
        <>
            <input
                name={props.name}
                type="text"
                value={addressG}
                id={props.id}
                placeholder={props.placeholder}
                autoComplete={"appyshop-" + props.dateJ}
                onChange={onChange}
                disabled={props.disabled}
            />
        </>
    );
}
